import {
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import {
  setCareDirectiveData,
  getCareDirectiveData,
} from "../../../services/documentServices";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { getKeyFromText } from "../../../utils/Utilities";

const IndividualWishes = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    individualWish: "",
    allowanceDescription: "",
    recipientPlace: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const validate = Yup.object({
    allowanceDescription: Yup.string().nullable(),
    individualWish: Yup.string().nullable(),
    recipientPlace: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const payload = {
      ...data,
      ...values,
    };
    const result = await setCareDirectiveData(payload, uID);
    if (result?.success) {
      // toast.success(t(getKeyFromText(result?.message)));
      next();
    }
    setButtonDisabled(false);
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const getCareDirectiveDataFun = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    try {
      const result = await getCareDirectiveData(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (
          result.payLoad.allowanceDescription !== null &&
          result.payLoad.individualWish !== null &&
          result.payLoad.recipientPlace !== null
        ) {
          setInitialValues({
            allowanceDescription: result.payLoad.allowanceDescription,
            individualWish: result.payLoad.individualWish,
            recipientPlace: result.payLoad.recipientPlace,
          });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={7}
            md={6}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate}
              onSubmit={handleSubmit}
            >
              {(formik) => {
                return (
                  <Form id="form_submit" onSubmit={formik.handleSubmit}>
                    <InputLabel sx={{ mt: 2, color: "color.magentaDark2" }}>
                      {t("cd-tab-5")}
                    </InputLabel>
                    <InputField
                      fullWidth
                      multiline
                      rows={3}
                      variant="outlined"
                      name="individualWish"
                      type="text"
                    />
                    <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                      {t("cd-iw-text-1")}
                    </FormHelperText>
                    <InputField
                      fullWidth
                      multiline
                      rows={3}
                      variant="outlined"
                      name="allowanceDescription"
                      type="text"
                    />
                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="Karlsruhe, 15th March 2022"
                      label={t("input-25")}
                      transKey={t("input-25")}
                      name="recipientPlace"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      sx={{ mt: 2, color: "color.magentaDark2" }}
                    />
                    <FormHelperText sx={{ mt: 2, color: "#9A9A9A" }}>
                      {t("cd-iw-text-2")}
                    </FormHelperText>
                  </Form>
                );
              }}
            </Formik>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default IndividualWishes;
